import { createRouter, createWebHistory } from 'vue-router'
import Home from "@/views/Home.vue";
import Limiti from "@/views/Limiti.vue";
import Misericordia from "@/views/Misericordia.vue";
import Natura from "@/views/Natura.vue";
import TestoCantico from "@/views/TestoCantico.vue";
import Vita from "@/views/Vita.vue";
import QuizVita from "@/views/QuizVita.vue";
import CruciverbaVita from "@/views/CruciverbaVita.vue";

const routes = [
  {
    path: "/",
    alias: "/home",
    name: 'home',
    component: Home
  },
  {
    path: '/limiti',
    name: 'limiti',
    component: Limiti
  },
  {
    path: '/misericordia',
    name: 'misericordia',
    component: Misericordia
  },
  {
    path: '/natura',
    name: 'natura',
    component: Natura
  },
  {
    path: '/testo-cantico',
    name: 'testo-cantico',
    component: TestoCantico
  },
  {
    path: '/vita',
    name: 'vita',
    component: Vita
  },
  {
    path: '/quiz-vita',
    name: 'quiz-vita',
    component: QuizVita
  },
  {
    path: '/cruciverba-vita',
    name: 'cruciverba-vita',
    component: CruciverbaVita
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
